/* eslint-disable react/require-extension */

const onWindowIntl = () => {
  require('babel-polyfill')
  //window.Promise = require('../common/configureBluebird')

  // App locales are defined in src/server/config.js
  const { addLocaleData } = require('react-intl')
  const en = require('react-intl/locale-data/en')
  const cs = require('react-intl/locale-data/cs')
  const sk = require('react-intl/locale-data/sk')

  addLocaleData(en)
  addLocaleData(cs)
  addLocaleData(sk)

  require('./main')
}


if (!window.Intl) {
  require.ensure([
    'intl',
    'intl/locale-data/jsonp/en.js',
    'intl/locale-data/jsonp/cs.js',
    'intl/locale-data/jsonp/sk.js',
  ], (require) => {
    require('intl')
    require('intl/locale-data/jsonp/en.js')
    require('intl/locale-data/jsonp/cs.js')
    require('intl/locale-data/jsonp/sk.js')

    onWindowIntl()
  })
} else {
  onWindowIntl()
}



// WEBPACK FOOTER //
// ./src/browser/index.js